import React, { type FC } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "@app/store/useAuthStore";
import { AppPaths } from "./paths";

/**
 * Защищённый маршрут: доступ только для авторизованных пользователей.
 */
const PrivateRoute: FC = () => {
    const isAuthenticated = useAuthStore((state) => state.isAuthenticated());

    return isAuthenticated ? <Outlet /> : <Navigate to={AppPaths.AUTH} replace />;
};

export default PrivateRoute;
